import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more.js";
import Exporting from "highcharts/modules/exporting.js";
import ExportData from "highcharts/modules/export-data.js";
import BubbleChart from "app/components/charts/BubbleChart";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import {occupationBubbleChartData} from "app/utils"
import "./OccupationBubbleChart.css"

HighchartsMore(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: "#899DB9",
    border: "1px solid #ced4da",
    color: "#FFFFFF",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

const menuItemStyle = {
  "background-color": "#0F3E6E",
  color: "#FFFFFF",
  "& .MuiMenuItem-root": {
    whiteSpace: "normal",
  },
};

let minX = 10000;

class OccupationBubbleChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusOccupation: "",
    };
    this.bubbleChartRef = React.createRef();
  }

  componentWillUpdate(prevState, prevProps) {
    if (prevProps.occupationData !== this.props.occupationData) {
      minX = 10000;
    }
  }

  getSeriesData = (occupationData) => {
    let currentLabels;
    this.props.crossFactorTypes.forEach((category) => {
      if (category.name == this.props.crossFactorTypeSelected) {
        currentLabels = category.label;
      }
    });
    let ind = -1;
    let seriesData = occupationData.map((item) => {
      let minItem = Math.min(...item.data.map((i) => i.x));
      minItem = minItem > 10000 ? minItem - 10000 : 0;
      minX = minItem < minX ? minItem : minX;
      let currentColor;
      currentLabels.forEach((legendLabel) => {
        if (legendLabel.name == item.name) {
          currentColor = legendLabel.color;
        }
      });
      ind++;
      return {
        ...item,
        color: currentColor,
        showInLegend: true,
        marker: {
          lineColor: currentColor,
        },
      };
    });
    minX = Math.floor(minX / 10000) * 10000;
    return seriesData;
  };

  getDataIndices = (seriesData, occupation) => {
    let seriesInd = -1;
    let dataInd = -1;
    let logger = [];
    for (let i = 0; i < seriesData.length; i++) {
      const series = seriesData[i];
      let ind = series.data.findIndex((x) => {
        logger.push(x.name);
        return x.name === occupation;
      });
      if (ind !== -1) {
        seriesInd = i;
        dataInd = ind;
        break;
      }
    }
    return { seriesInd: seriesInd, dataInd: dataInd };
  };

  syncWithFocusOccupation = (seriesData) => {
    if (this.props.focusOccupation !== this.state.focusOccupation) {
      if (this.bubbleChartRef && this.bubbleChartRef.current) {
        const chart = this.bubbleChartRef.current.chart;
        if (chart && chart.series) {
          let { seriesInd, dataInd } = {
            ...this.getDataIndices(chart.series, this.props.focusOccupation),
          };
          let prevSeriesMatch = this.getDataIndices(
            chart.series,
            this.state.focusOccupation
          );
          let prevSeriesInd = prevSeriesMatch.seriesInd,
            prevDataInd = prevSeriesMatch.dataInd;
          if (prevDataInd !== -1) {
            chart.series[prevSeriesInd].points[prevDataInd].update({
              color: chart.series[prevSeriesInd].color,
            });
            chart.tooltip.hide();
          }
          if (dataInd !== -1) {
            chart.series[seriesInd].points[dataInd].update({
              color: "#00FFFF",
            });
            chart.tooltip.refresh(chart.series[seriesInd].points[dataInd]);
          }
        }
      }
      this.setState({ focusOccupation: this.props.focusOccupation });
    }
  };

  render() {
    let seriesData = this.getSeriesData(this.props.occupationData);
    this.syncWithFocusOccupation(seriesData);
    return (
      <div className="graph-wrapper graph-wrapper-4 screen-left-graph-container">
        <div className="graph-title-container-screen graph-title-container-screen4">
          <div className="graph-title occupation-trends-title">
            Occupation Trends
          </div>
          <div className="graph-dropdown graph-dropdown-4 cross-factor">
            <FormControl sx={{ width: "350px", marginTop: "50px" }}>
              {/* <Typography
                sx={{ height: "40px", display: "block" }}
                variant="inherit"
                className="form-metrics-header"
                id="cross-factor-heading"
              >
                Cross factor
              </Typography> */}
              <Select
                value={this.props.crossFactorTypeSelected}
                onChange={this.props.handleCrossFactorTypeChange}
                input={<BootstrapInput />}
                inputProps={{ "aria-label": "Without label" }}
                // MenuProps={{ PaperProps: { sx: { maxHeight: "400px" } } }}
                className="select-mui occupation-trends-menu"
                displayEmpty
              >
                <MenuItem disabled value="">
                  <Typography variant="inherit" noWrap>
                    Select a Cross Factor
                  </Typography>
                </MenuItem>
                {this.props.crossFactorTypes.length
                  ? this.props.crossFactorTypes.map((elem, i) => (
                      <MenuItem key={i} value={elem.name}>
                        <Typography variant="inherit" noWrap>
                          {elem.name}
                        </Typography>
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="graph-screen graph-screen2">
          <div className="individual-graph-4" id="screen4-bubble">
            {this.props.occupationData.length != 0 &&
            (this.props.occupationData[0].data.length != 0 ||
              this.props.occupationData[1].data.length != 0 ||
              this.props.occupationData[2].data.length != 0) ? (
              <BubbleChart
                containerId="occupationBubbleChart"
                bubbleChartRef={this.bubbleChartRef}
                remainingOptions={{
                  chart: {
                    animation: false,
                    type: "bubble",
                    plotBorderWidth: 1,
                    zoomType: "xy",
                    backgroundColor: "transparent",
                    height: 710,
                    width: 890,
                    spacingTop: 10,
                    marginRight: 30,
                  },

                  title: {
                    text: null,
                  },

                  xAxis: {
                    min: minX,
                    startOnTick: true,
                    endOnTick: true,
                    tickInterval: 10000,
                    gridLineWidth: 0.5,
                    title: {
                      text: "Starting Salary",
                      style: {
                        color: "#fff",
                        font: "normal normal normal 18px Arial",
                      },
                    },
                    labels: {
                      style: {
                        color: "#fff",
                        font: "normal normal normal 18px Arial",
                      },
                      formatter: function() {
                        return "$" + (this.value / 1000).toString() + "K";
                      },
                    },
                    plotLines: [
                      {
                        color: "#fff",
                        dashStyle: "solid",
                        width: 3,
                        value: occupationBubbleChartData[this.props.regionSelected]?.childAdultMin,
                        zIndex: 3,
                        label: {
                          rotation: 0,
                          y: -15,
                          verticalAlign: "bottom",
                          style: {
                            color: "#fff",
                          },
                          text: occupationBubbleChartData[this.props.regionSelected]?.childAdultMin?.toLocaleString(),
                        },
                      },
                      {
                        color: "#fff",
                        dashStyle: "solid",
                        width: 3,
                        value: occupationBubbleChartData[this.props.regionSelected]?.childAdultMax,
                        zIndex: 3,
                        label: {
                          rotation: 0,
                          y: -15,
                          verticalAlign: "bottom",
                          style: {
                            color: "#fff",
                          },
                          text: occupationBubbleChartData[this.props.regionSelected]?.childAdultMax?.toLocaleString(),
                        },
                      },
                    ],
                    plotBands: [
                      {
                        color: "#0873DD",
                        from: 0,
                        to: 36254,
                      },
                      {
                        color: "#0657A7",
                        from: 36255,
                        to: 51000,
                      },
                      {
                        color: "#06498B",
                        from: 51001,
                        to: 67038,
                      },
                    ],
                  },

                  yAxis: {
                    min: 75,
                    max: 135,
                    startOnTick: false,
                    endOnTick: true,
                    tickInterval: 5,
                    gridLineWidth: 0.5,
                    title: {
                      text: "Automation Index",
                      style: {
                        color: "#fff",
                        font: "normal normal normal 18px Arial",
                      },
                    },
                    labels: {
                      format: "{value}",
                      style: {
                        color: "#fff",
                        font: "normal normal normal 18px Arial",
                      },
                    },
                    maxPadding: 0.2,
                    plotLines: [
                      {
                        color: "#fff",
                        dashStyle: "solid",
                        width: 3,
                        value: 100,
                        zIndex: 3,
                      },
                    ],
                  },

                  tooltip: {
                    borderRadius: 15,
                    borderWidth: 1,
                    borderColor: "#707070",
                    backgroundColor: "#FFFFFF",
                    padding: 17,
                    shape: "square",
                    style: {
                      font: "Arial",
                      fontSize: 14,
                      color: "#333333",
                    },
                    useHTML: true,
                    headerFormat: "<table>",
                    pointFormat:
                      "<tr><td style='border: none;'>Occupation:</td><th style='border: none;'>{point.name}</th></tr>" +
                      "<tr><td style='border: none;'> Starting Salary:</td><th style='border: none;'>${point.x:,.0f}</th></tr>" +
                      "<tr><td style='border: none;'>2023 Jobs:</td><th style='border: none;'>{point.z}</th></tr>",
                    footerFormat: "</table>",
                    followPointer: true,
                  },

                  plotOptions: {
                    series: {
                      dataLabels: {
                        enabled: false,
                        format: "{point.name}",
                      },
                    },
                  },

                  series: seriesData,
                  exporting: { enabled: false },
                  legend: {
                    itemStyle: {
                      color: "#FFF",
                      font: "normal normal normal 16px/27px Arial",
                    },
                    verticalAlign: "top",
                    align: "center",
                    backgroundColor: "transparent",
                    padding: 10,
                    itemMarginTop: 5,
                    itemMarginBottom: 5,
                    symbolRadius: 0,
                    symbolWidth: 15,
                    symbolHeight: 15,
                  },
                }}
              />
            ) : (
              <div style={{ textAlign: "center", paddingTop: "400px" }}>
                {" "}
                No data available{" "}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default OccupationBubbleChart;
